import { useSearchParams } from 'react-router-dom';
import { AuditLogTable } from '@/features/admin/components/AuditLogTable';

export function AuditLog() {
  // Allow the customer detail "View full activity log" link to deep-link
  // with a pre-selected customer filter.
  const [searchParams] = useSearchParams();
  const customerId = searchParams.get('customerId') ?? undefined;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-semibold">Audit log</h1>
      <AuditLogTable showFilters={true} defaultCustomerIdFilter={customerId} />
    </div>
  );
}
